import styled from 'styled-components';

const CallToActionStyle = styled.div`
	--padTB: var(--sp15x);
	--marginLR: var(--sp7x);
	--marginB: var(--sp6x);
	--descMarginT: var(--sp5x);
	--btnMarginT: var(--sp7x);
	--borderRadius: var(--sp7x);
	--iconPad: var(--sp1-5x) var(--sp2-5x);

	&.active {
		.empty-bg {
			transition: calc(var(--trTime) * 2) ease-out;
			transform: scale(1);
		}

		.call-to-action-container {
			&:before {
				transform: translate(-14%, -44%) scaleY(1);
				transition: calc(var(--trTime) * 2) ease-out;
				transition-delay: 0.3s;
			}
		}

		.cols-svg {
			opacity: 1;
			transition: calc(var(--trTime) * 2) ease-out;
			transition-delay: 0.3s;
		}
	}

	.cols-svg {
		width: 100%;
		height: 100%;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 1;
		opacity: 0;

		.wrapper-svg {
			width: 100%;
			height: 100%;
			.image-cont {
				--proportion: 0;
				width: 100%;
				height: 100%;

				img {
					position: unset !important;
					object-position: top !important;
					object-fit: contain !important;
				}
			}
		}
	}

	.outside-wrapper {
		margin: 0 var(--marginLR) var(--marginB) var(--marginLR);
		position: relative;
	}

	.wrapper-icon,
	.button-wrapper {
		width: fit-content;
		height: fit-content;
		transform: scale(0);
		position: relative;
		z-index: 2;
	}

	.empty-bg {
		position: absolute;
		z-index: 0;
		width: 100%;
		height: 100%;
		background-color: var(--darkGreen1000);
		border-radius: var(--borderRadius);
		transform: scaleX(0);
		transform-origin: center center;
	}

	.call-to-action-container {
		color: var(--white);
		border-radius: var(--borderRadius);
		width: unset;
		position: relative;
		overflow: hidden;

		.call-to-text-wrapper {
			padding: var(--padTB) 0;
		}

		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 50%;
			transform: translate(-14%, -44%) scaleY(0);
			width: 126%;
			height: 56px;
			pointer-events: none;
			background: radial-gradient(circle at top right, transparent 73%, #48bb16 43%);
			filter: blur(62px);
			z-index: 1;
			transform-origin: top;
		}
	}

	.call-to-text-wrapper {
		display: flex;
		flex-direction: column;
		align-items: center;
		text-align: center;

		.title-other {
			position: relative;
			z-index: 2;
		}

		.desc {
			margin-top: var(--descMarginT);
			position: relative;
			z-index: 2;
		}

		.button-wrapper {
			margin-top: var(--btnMarginT);

			.text {
				transition: var(--trTime) ease-out;
			}
		}

		.icon {
			color: var(--darkGreen1000);
			background-color: var(--green);
			padding: var(--iconPad);
			border-radius: 50%;
			aspect-ratio: 1/1;
			display: flex;
			align-items: center;
			justify-content: center;
		}
	}

	@media (pointer: fine) {
		@media (hover: hover) {
			.button {
				&:hover {
					background-color: var(--white);

					.text {
						color: var(--green);
					}
				}
			}
		}
	}
	//! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--marginLR: var(--sp6x);
		--marginB: var(--sp6x);
		--padTB: var(--sp13x);
		--descMarginT: var(--sp3x);
		--btnMarginT: var(--sp5x);
		--borderRadius: var(--sp6x);
		--iconPad: var(--sp1-5x) var(--sp2x);
	}

	//! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--marginLR: var(--sp4x);
		--marginB: var(--sp5x);
		--padTB: var(--sp9x);
		--descMarginT: var(--sp2-5x);
		--btnMarginT: var(--sp4x);
		--borderRadius: var(--sp5x);
	}

	//! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--marginLR: var(--sp3x);
		--marginB: var(--sp5x);
		--padTB: var(--sp9x);
		--descMarginT: var(--sp2x);
		--btnMarginT: var(--sp3x);
		--borderRadius: var(--sp5x);
		--iconPad: var(--sp1x) var(--sp1-5x);
	}

	//! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
		--marginLR: var(--sp3x);
		--marginB: var(--sp4x);
		--padTB: var(--sp6x);
		--descMarginT: var(--sp2x);
		--btnMarginT: var(--sp3x);
		--borderRadius: var(--sp4x);
	}

	//! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		--marginLR: var(--sp3x);
		--marginB: var(--sp4x);
		--padTB: var(--sp5x);
		--descMarginT: var(--sp2x);
		--btnMarginT: var(--sp3x);
		--borderRadius: var(--sp3x);
	}

	//! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--marginLR: var(--sp3x);
		--marginB: var(--sp4x);
		--padTB: var(--sp5x);
		--descMarginT: var(--sp2x);
		--btnMarginT: var(--sp3x);
		--borderRadius: var(--sp3x);
	}

	//! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		--marginLR: var(--sp2x);
		--marginB: var(--sp4x);
		--padTB: var(--sp8x);
		--descMarginT: var(--sp2x);
		--btnMarginT: var(--sp3x);
		--borderRadius: var(--sp2x);
		--iconPad: 5px var(--sp1x);

		.call-to-text-wrapper {
			padding-right: var(--sp1x) !important;
			padding-left: var(--sp1x) !important;
		}
	}
`;

export default CallToActionStyle;
